import React, { Component, Fragment } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Typography, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import * as requests from '../../infrastructure/requests';
import {
    Map,
    Marker,
    PaginatedStaticDataTable,
    VSpacer,
    ClusterGroup
} from 'sm-react-components';
import * as formatters from '../formatters';
import RequestsInspector from './RequestsInspector';

const styles = {};

class PlaceSummary extends Component {
  state = {
      selected: undefined,
      placesVisited: [],
      placesUnvisited: [],
      checkboxVisited: true,
      checkboxUnvisited: true,
      loading: true
  };

  componentDidMount = async () => {
      const { keyData } = this.props;
      this.setState({ loading: true });
      requests
          .placesSummary(keyData.key)
          .then(resp => {
              const placesVisited = [];
              const placesUnvisited = [];

              resp &&
          resp.places &&
          Object.values(resp.places).forEach(place => {
              let durationDefault = 0;
              place.durations.forEach(duration => {
                  if (duration.service_id === 'default') {
                      durationDefault = duration.mean;
                  }
              });
              if (place.visit_count > 0) {
                  placesVisited.push({
                      location: place.location,
                      parkings: place.coordinates,
                      type: 'place',
                      id: place.id,
                      duration: durationDefault,
                      timewindows: place.timewindows,
                      visitcount: place.visit_count,
                      place
                  });
              } else {
                  placesUnvisited.push({
                      location: place.location,
                      parkings: place.coordinates,
                      type: 'place',
                      id: place.id,
                      duration: durationDefault,
                      timewindows: place.timewindows,
                      visitcount: place.visit_count,
                      place
                  });
              }
          });
              this.setState({ placesUnvisited, placesVisited, loading: false });
          })
          .catch(error => {
              this.setState({ loading: false });
          });
  };

  handleSelectPlace = place => {
      this.setState({
          selected: place
      });
  };

  handleChangeCheckbox = (event, value) => {
      const { id } = event.target;
      this.setState(prevState => ({
          ['checkbox' + id]: value,
          selected: undefined
      }));
  };

  render() {
      const {
          placesUnvisited,
          placesVisited,
          selected,
          checkboxVisited,
          checkboxUnvisited,
          loading
      } = this.state;
      const places = [
          ...(checkboxVisited ? placesVisited : []),
          ...(checkboxUnvisited ? placesUnvisited : [])
      ];
      if (loading) {
          return (
              <Fragment>
                  <Skeleton width="100%" height="47px" />
                  <VSpacer small />
                  <Grid container spacing={16}>
                      <Grid
                          item
                          lg={5}
                          style={{ maxHeight: '540px', overflow: 'scroll' }}
                      >
                          <Skeleton height="42px" />
                          <VSpacer small />
                          <Skeleton height="42px" />
                          <VSpacer small />
                          <Skeleton height="42px" />
                          <VSpacer small />
                          <Skeleton height="42px" />
                          <VSpacer small />
                          <Skeleton height="42px" />
                          <VSpacer small />
                          <Skeleton height="42px" />
                          <VSpacer small />
                          <Skeleton height="42px" />
                          <VSpacer small />
                          <Skeleton height="42px" />
                          <VSpacer small />
                          <Skeleton height="42px" />
                          <VSpacer small />
                          <Skeleton height="42px" />
                          <VSpacer small />
                      </Grid>
                      <Grid item lg={7} style={{ maxHeight: '540px' }}>
                          <Skeleton width="100%" height="540px" />
                      </Grid>
                  </Grid>
              </Fragment>
          );
      }
      if (placesUnvisited.length === 0 && placesUnvisited.length === 0) {
          return (
              <Grid container justify="center">
                  <Typography variant="h2">No places </Typography>
              </Grid>
          );
      }
      return (
          <Fragment>
              <RequestsInspector
                  data={{
                      count: places && places.length,
                      visited: {
                          checkboxVisited,
                          label: 'Visited',
                          onChange: this.handleChangeCheckbox
                      },
                      unvisited: {
                          checkboxUnvisited,
                          label: 'Unvisited',
                          onChange: this.handleChangeCheckbox
                      }
                  }}
                  type="placesWithSelection"
              />
              <VSpacer small />
              <Grid container spacing={16}>
                  <Grid item lg={5} style={{ maxHeight: '520px', overflow: 'scroll' }}>
                      {places ? (
                          <PaginatedStaticDataTable
                              docs={places}
                              mapping={[
                                  { column: 'id', name: 'Id', sortable: true },
                                  {
                                      column: 'visitcount',
                                      name: 'Visits',
                                      sortable: true
                                  },
                                  {
                                      column: 'duration',
                                      name: 'Duration',
                                      formatter: formatters.duration,
                                      sortable: true
                                  },
                                  {
                                      column: 'timewindows',
                                      name: 'Time',
                                      formatter: formatters.timewindowWithTooltip
                                  }
                              ]}
                              onRowClick={this.handleSelectPlace}
                              selectionByProps={selected}
                              search="live"
                          />
                      ) : (
                          <Typography component="span">No data</Typography>
                      )}
                  </Grid>
                  <Grid item lg={7} style={{ maxHeight: '520px' }}>
                      {places && (
                          <Map height={520}>
                              <ClusterGroup>
                                  {places &&
                    places.map((item, index) => {
                        const poiKey = 'places-poi-' + index;
                        const id = selected && selected.id;

                        if (!selected || item.id !== selected.id) {
                            return (
                                <Marker
                                    key={poiKey}
                                    onClick={() => this.handleSelectPlace(item)}
                                    lat={item.location.lat}
                                    lng={item.location.lng}
                                    selected={item.id === id}
                                    kind={item.type}
                                    visited={item.visitcount > 0}
                                />
                            );
                        }
                        return <Fragment />;
                    })}
                              </ClusterGroup>
                              {selected && (
                                  <Marker
                                      key={'place-poi-selected' + selected.id}
                                      lat={selected.location.lat}
                                      lng={selected.location.lng}
                                      kind="place"
                                      selected
                                  />
                              )}
                              {selected &&
                  selected.parkings &&
                  selected.parkings.map((parking, index) => {
                      return (
                          <Marker
                              key={'parkings-poi-' + index}
                              lat={parking.lat}
                              lng={parking.lng}
                              kind="parking"
                          />
                      );
                  })}
                          </Map>
                      )}
                  </Grid>
              </Grid>
          </Fragment>
      );
  }
}

export default withStyles(styles)(PlaceSummary);
